import { InfoCircleFill } from 'react-bootstrap-icons';
import '../CSS/ExtraCard.css'
function ExtraCard() {
  return (
    <div className="ec-card">
      <div className="ec-card-header">
        <InfoCircleFill className="ec-header-icon" />
        <strong className="ec-header-title">Note</strong>
      </div>
      <div className="ec-card-body">
        <p className="ec-card-text">
          Totals exclude expelled, passed out &amp; withdrawn students.
          To ensure that totals remain accurate and up to date in the database,
          always record both the student's school fees and miscellaneous fees
          immediately after successful registration.
        </p>
      </div>
    </div>
  );
}

export default ExtraCard;
